import { IBankSchema } from '../../../repositories/newbuilding-card/entities/promo/BankSchema';

export const getBankLogoUrl = (bank: IBankSchema): string | null => {
  return bank.secondSquareImageUrl || bank.logoUrl || null;
};
